var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusSign = function SvgPlusSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 14.1h-9.3V4.8c0-1-.9-1.8-1.9-1.8s-1.9.8-1.9 1.9v9.3H4.8C3.8 14.1 3 15 3 16s.8 1.9 1.9 1.9h9.3v9.3c0 1 .8 1.9 1.9 1.9s1.9-.8 1.9-1.9v-9.3h9.3c1 0 1.9-.8 1.9-1.9s-1-1.9-2-1.9"
  })));
};
export default SvgPlusSign;